export const contacts = [
    {
        city: 'Суми',
        phone: '+38 (099) 446 44 20'
    },
    {
        city: 'Конотоп',
        phone: '+38 (066) 577 53 01'
    },
    {
        city: 'Глухів',
        phone: '+38 (095) 752 13 15'
    },
    {
        city: 'Ямпіль',
        phone: '+38 (095) 341 52 96'
    },

]